import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import {
  CHECKOUT_GEO_PRICING_RULE_ID,
  CheckoutGeoPricingResult,
  CheckoutGeoPricingTestData,
  CheckoutGeoPricingVariant,
  UseCheckoutGeoPricing,
} from "./types";

const useCheckoutGeoPricing: UseCheckoutGeoPricing = () => {
  const { isLoading, value } = useMonarchRule<{
    data: CheckoutGeoPricingTestData;
  }>(CHECKOUT_GEO_PRICING_RULE_ID, {});

  if (isLoading || !value?.data) {
    return {
      isLoading,
    } as CheckoutGeoPricingResult;
  }

  const variant: CheckoutGeoPricingVariant = value.data.isGeoPricingEnabled
    ? "test"
    : "control";

  return { isLoading: false, variant, data: value.data };
};

export default useCheckoutGeoPricing;
